<template>
  <div class="bio-profile" v-if="showpopup">
    <div class="exit" @click="$emit('update:showpopup', false)">
      <img src="/images/icons/close-btn.svg" alt="" />
    </div>
    <div class="overlay"></div>
    <div class="relative content">
      <div class="left">
        <img class="thumbnail" :src="member.image" alt="" />
        <div class="contacts">
          <p class="name">{{ member.title }}</p>
          <a :href="'mailto:'+ member.email" class="email">{{ member.email }}</a>
          <a :href="'tel:' + member.phone" class="number">{{ member.phone }}</a>
        </div>
        <div class="socials">
          <a :href="member.facebook" target="_blank"><img src="/images/icons/fb-circle.svg" alt="" /></a>
          <a :href="member.linkedin" target="_blank"><img src="/images/icons/linkedin-circle.svg" alt="" /></a>
        </div>
      </div>

      <div class="right">
        <div class="heading-title">
          <p class="name">{{ member.title }}</p>
          <span>{{ member.position }} <span v-if="member.id_number">(#{{ member.id_number }})</span></span>
          <div class="divider"></div>
        </div>
        <div class="wysiwyg" v-html="nl2br(member.content)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showpopup: {
      type: Boolean,
      default: true,
    },
    member: {
      type: Object,
      default: true,
    },
  },
  methods: {
    nl2br (str, replaceMode, isXhtml) {
      var breakTag = (isXhtml) ? '<br />' : '<br>';
      var replaceStr = (replaceMode) ? '$1'+ breakTag : '$1'+ breakTag +'$2';
      return '<p>' + (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr) + '</p>';
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ProfileModal.vue